import { render } from "./packageDetails.vue?vue&type=template&id=9f9cb23c&scoped=true"
import script from "./packageDetails.vue?vue&type=script&lang=js"
export * from "./packageDetails.vue?vue&type=script&lang=js"

import "./packageDetails.vue?vue&type=style&index=0&id=9f9cb23c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f9cb23c"]])

export default __exports__